import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { BackAndMultipleButtons, ContinueButton, ContinueWithBackButtons, SaveTempButton } from 'components/base/BottomStepComponent';

import { scrollToAnchor } from './CreateCampaignHandleError';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATE_CAMPAIGN_EARNING_PAGE_CONFIG } from 'containers/engagement/campaignStreamline/CreateCampaignEarningPageConfig';
import RequireCampaignNamePrompt from './RequireCampaignNamePrompt';
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';

import '../campaign/campaignCreation/CouponCampaignSection.scss';
import './CreateCampaignEarningPage.scss';

const CreateCampaignEarningPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
}) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    watch,
    formState: { errors },
    getValues,
  } = useFormContext();

  const watchName = getValues('translations.en.generalName');
  const [showRequireNamePrompt, setShowRequireNamePrompt] = useState(false);
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];
  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  const saveDraftAction = () => {
    dispatch({
      type: 'createCampaign/createOrUpdateCampaignV2',
      payload: {
        data: getValues(),
        actionType: ActionType.save,
        resume: location.state?.resume,
      }
    });
  };

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  useEffect(() => {
    console.log("@@createCampaignEarningPage", anchorKey, sectionKey);
    scrollToAnchor(anchorKey, sectionKey, -100);
  }, [anchorKey, sectionKey]);

  const stepChangeAction = (step) => {
    setFieldsError(0);
    dispatch({
      type: 'campaignStreamline/stepChange',
      payload: { step: step },
    });
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_CAMPAIGN_EARNING_PAGE_CONFIG}
        hidePreview
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
      // sectionStyle='create-campaign-streamline-step-3'
      />
      <BackAndMultipleButtons
        backAction={() => stepChangeAction(1)}
        multipleButtons={[
          ...(
            params.id
              ? []
              : [
                <SaveTempButton
                  text="Save as draft"
                  action={() => {
                    if (!watchName) {
                      setShowRequireNamePrompt(true);
                      return;
                    };
                    saveDraftAction();
                  }}
                />
              ]
          ),
          <ContinueButton
            text="Continue"
            action={() => {
              stepChangeAction(3);
            }}
          />,
        ]}
      />
      <RequireCampaignNamePrompt
        show={showRequireNamePrompt}
        onHide={() => {
          setShowRequireNamePrompt(false);
        }}
        onConfirm={() => {
          setShowRequireNamePrompt(false);
          saveDraftAction();
        }}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={CampaignType.earningRulesCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/campaigns'}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});

export default connect(mapStateToProps)(CreateCampaignEarningPage);
